<template>
  <div class="right-panel">
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped></style>